import { User } from '../types/general'
import { KftApiDefaultResponse } from '../types/kft-api'
import type { Order } from '~/composables/types/checkout'

export default function useAccount() {
  const { getAccessToken } = useAuthTokens()
  const orders = useState<Order[]>('orders', () => [])
  const user = useState<KftApiDefaultResponse<User> | null>('user', () => null)

  const userBalance = computed(() => {
    const userValue = user.value as {
      data?: { balance?: { amount: number } }
    } | null

    if (!userValue) {
      return 0
    }

    return userValue?.data?.balance?.amount
      ? userValue.data.balance.amount / 100
      : 0
  })

  async function fetchProfile() {
    try {
      const token = await getAccessToken()
      const profile = await kftApiRequest<User>(
        '/v1/user/profile?include=customer,referralCoupon&with_session=1',
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      )

      user.value = profile
    } catch (err) {
      console.error('Fetch profile error', err)
      user.value = null
    }
  }

  function cleanProfile() {
    user.value = null
    orders.value = []
  }

  async function getUserOrders(page: number = 1) {
    try {
      const token = await getAccessToken()
      const response = await kftApiRequest<Order[]>(
        `/v1/checkout/orders/?orderBy=created_at&sortedBy=desc&page=${page}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      )

      if (response.data) {
        orders.value = orders.value.concat(response.data)
      }
    } catch (err) {
      console.error('Fetch orders error', err)
      throw err
    }
  }

  return {
    orders,
    user,
    userBalance,
    fetchProfile,
    cleanProfile,
    getUserOrders,
  }
}
